export enum LIST_ACTIONS {
  BILL = 'BILL',
  DETAIL = 'DETAIL',
  POD = 'POD',
  OPEN_REFUND_MODAL = 'OPEN_REFUND_MODAL',
  SET_STATUS_PAID = 'SET_STATUS_PAID',
  EDIT_DESTINATION_MODAL = 'EDIT_DESTINATION_MODAL',
  DELETE_DESTINATION_MODAL = 'DELETE_DESTINATION_MODAL',
  GO_TO_PAYMENT = 'GO_TO_PAYMENT',
  SHOW_POPIN_CONTACT = 'SHOW_POPIN_CONTACT',
  CLOSE_TRANSPORT = 'CLOSE_TRANSPORT',
  DETAIL_TRANSPORT = 'DETAIL_TRANSPORT',
  RESET_TRANSPORT = 'RESET_TRANSPORT',
  UPDATE = 'UPDATE',
  REMOVE = 'REMOVE',
  DUPLICATE = 'DUPLICATE',
}
